import React from "react"

const BoxTitle = ({name}) => (
    <h5 className="box-title">{name}</h5>
)

export default BoxTitle